module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/zalo_login-748c44a854a7be7825c75242d2f5664e.png";